import { IconProps, NocIconGenerator } from '../common';

export const PlusMinus = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'PlusMinus',
            path: (
                <g>
                    <path
                        d="M6 8h12M12 14V2"
                        stroke="#292D32"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6 20h12"
                        stroke="#292D32"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            ),
        }}
    />
);
